import { camelCase } from 'lodash';

export class Feature {
  id: number = null;
  title: string = null;
  content: string = null;
  active: boolean = null;
  dateCreated: Date = null;

  constructor(obj?: any) {
    for (const field in obj) {
      const camelCasedField = camelCase(field);
      if (typeof this[camelCasedField] !== 'undefined') {
        this[camelCasedField] = obj && obj[field];
      }
    }
  }
}
